import { NgModule } from '@angular/core';
import { ScullyLibModule } from '@scullyio/ng-lib';
import { HttpClientModule } from '@angular/common/http';
import { FlexLayoutModule } from '@angular/flex-layout';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { LayoutModule } from 'app/layout/layout.module';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule } from 'ngx-google-analytics';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        FlexLayoutModule,
        HttpClientModule,
        BrowserAnimationsModule,
        LayoutModule,
        AppRoutingModule,
        LazyLoadImageModule,
        NgxGoogleAnalyticsModule.forRoot('G-MXYC5FH7Q6'),
        NgxGoogleAnalyticsRouterModule,
        ScullyLibModule.forRoot({
            useTransferState: true,
            alwaysMonitor: true,
        }),
    ],
    providers: [
        { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 2500 } }
    ],
    bootstrap: [AppComponent],
})
export class AppModule { }
